import { render, staticRenderFns } from "./groupSample.vue?vue&type=template&id=217dbfcf&scoped=true"
import script from "./groupSample.vue?vue&type=script&lang=js"
export * from "./groupSample.vue?vue&type=script&lang=js"
import style0 from "./groupSample.vue?vue&type=style&index=0&id=217dbfcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217dbfcf",
  null
  
)

export default component.exports